module.exports = __webpack_public_path__ + "media/images/map-icons/icon2_selected@2x-589098aa098c064491d4d58d32d80508.png";